import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as uiActions from 'modules/ui';

import { TogglePalette } from 'components/Shared';

class PaletteContainer extends PureComponent {

  render() {
    const { color, palette, isShowPalette, UIActions } = this.props;

    return (
      <div>
        <TogglePalette
          color={color}
          palette={palette}
          openPalette={UIActions.openPalette}
          isShowPalette={isShowPalette}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    color: state.ui.get('color'),
    palette: state.ui.get('palette'),
    isShowPalette: state.ui.get('isShowPalette')
  }),
  (dispatch) => ({
    UIActions: bindActionCreators(uiActions, dispatch)
  })
)(PaletteContainer);



// WEBPACK FOOTER //
// ./src/containers/PaletteContainer.js